import { Navigation, Scrollbar } from 'swiper/modules';
import Swiper from 'swiper';

export default function initCategorySlider(id: string | undefined) {
  function initSliders() {
    function initCategoryClick(navSliderEl: HTMLElement, swiper: Swiper) {
      const navItems = navSliderEl.querySelectorAll('.ais-Menu-link');
      if (navItems.length > 0) {
        navItems.forEach((item) => {
          item.addEventListener('click', () => {
            // @ts-ignore
            swiper.slideTo(0, 500);
          });
        });
        (navItems[0] as HTMLElement).click();
      }
    }

    const root = document.getElementById(`category-slider-${id}`);
    if (root) {
      const navSliderEl = root.querySelector('.category-slider-nav-swiper') as HTMLElement;
      if (navSliderEl) {
        /* eslint-disable no-new */
        new Swiper(navSliderEl, {
          modules: [Navigation],
          spaceBetween: 16,
          slidesPerView: 'auto',
          navigation: {
            nextEl: `#category-slider-${id} .category-slider-nav-next`,
            prevEl: `#category-slider-${id} .category-slider-nav-prev`,
            disabledClass: 'hidden',
          },
          mousewheel: {
            enabled: true,
            releaseOnEdges: true,
          },
          breakpoints: {
            1024: {
              spaceBetween: 40,
            },
          },
        });
      }
      const productSlider = root.querySelector('.product-swiper');
      if (productSlider) {
        const swiper = new Swiper(productSlider as HTMLElement, {
          modules: [Scrollbar, Navigation],
          slidesPerView: 'auto',
          scrollbar: {
            el: `#category-slider-${id} .product-swiper-scrollbar`,
            draggable: true,
            dragClass: 'swiper-scrollbar-drag bg-gray-600! rounded-none! cursor-grab',
          },
          navigation: {
            nextEl: `#category-slider-${id} .product-swiper-button-next`,
            prevEl: `#category-slider-${id} .product-swiper-button-prev`,
            disabledClass: 'opacity-40 cursor-not-allowed pointer-events-none',
          },
          spaceBetween: 16,
        });

        if (navSliderEl) {
          setTimeout(() => initCategoryClick(navSliderEl, swiper), 300);
        }
      }
    }
  }

  initSliders();
}
